import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideCopy, lucideX } from '@ng-icons/lucide';
import { Button } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-custom-toast',
  imports: [ToastModule, NgIcon, Button, TooltipModule],
  viewProviders: [provideIcons({ lucideCopy, lucideX })],
  templateUrl: './custom-toast.component.html',
  styleUrl: './custom-toast.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomToastComponent {
  @Input() key: string | undefined;
  @Input() position:
    | 'top-left'
    | 'top-center'
    | 'top-right'
    | 'bottom-left'
    | 'bottom-center'
    | 'bottom-right'
    | 'center' = 'top-center';
  @Input() positionType: 'absolute' | 'relative' = 'absolute';
  @Input() life: number = 3000;
  @Input() closable: boolean = true;
  @Input() copyEnabled: boolean = true;

  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text);
  }

  severityIcon(severity) {
    switch (severity) {
      case 'error':
        return 'exclamation-circle';
      case 'warning':
        return 'exclamation-triangle';
      case 'info':
        return 'info-circle';
      case 'success':
        return 'check-circle';
    }
    return 'info-circle';
  }
}
